import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Modal.module.scss";
import Button from "../button/Button";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  onSubmit?: () => void;
  footer?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  footer = true,
}) => {
  const { t } = useTranslation("translation");
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {title && <h2 className={styles.modalTitle}>{title}</h2>}
        <div className={styles.modalContent}>{children}</div>
        <div className={styles.btns}>
          {footer ? (
            <div className={styles.btns}>
              <Button className={styles.closeBtn} onClick={onClose}>
                {t("common.close") as string}
              </Button>
              <Button onClick={onSubmit}>{t("common.submit") as string}</Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Modal;
